<app-usuario-logado-info>
  <ng-template #body let-usuario>
    <div class="flex w-full flex-col gap-2">
      <button
        (click)="toggle()"
        appButton
        class="flex w-full flex-row justify-between gap-2 border border-gray-100 bg-gray-200/70 pl-0"
        variant="outline">
        <app-avatar-usuario [usuario]="usuario" class="h-9 w-9 rounded-r" variant="brand" />
        <span class="line-clamp-1 text-xs text-[#374151]">{{ usuario.nomeCompleto.toUpperCase() }}</span>
        <app-icon class="flex items-center text-content-tertiary" name="arrow_down" />
      </button>
      <ul [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'">
        <li>
          <button
            appButton
            class="flex w-full items-center justify-start rounded-md text-sm font-normal text-[#374151] transition-colors hover:bg-[#f5f5f5]"
            variant="link"
            (click)="abrirMeuPerfil()">
            <div class="flex items-center gap-2.5">
              <app-icon class="flex items-center" name="user_account" />
              <span>Meu perfil</span>
            </div>
          </button>
        </li>
        <li>
          <button
            appButton
            class="flex w-full items-center justify-start rounded-md text-sm font-normal text-[#374151] transition-colors hover:bg-[#f5f5f5]"
            variant="link"
            (click)="toggleModalTrocarSenha()">
            <div class="flex items-center gap-2.5">
              <app-icon class="flex items-center" name="reset_password" />
              <span>Alterar senha</span>
            </div>
          </button>
        </li>
        <li>
          <button
            appButton
            class="flex w-full items-center justify-start rounded-md text-sm font-normal text-[#374151] transition-colors hover:bg-[#f5f5f5]"
            type="button"
            variant="link">
            <div class="flex items-center gap-2.5">
              <app-icon class="flex items-center" name="logout_04" />
              <span>Sair do sistema</span>
            </div>
          </button>
        </li>
      </ul>
    </div>
  </ng-template>
</app-usuario-logado-info>
